import React, { Component } from 'react';
import SettingsForm from './SettingsForm';
import utils from '../../common/services/utils';
import Spinner from '../../common/components/Spinner';
import ReduxBlockUi from 'react-block-ui/redux';
import { MOVE_LESSONS_REQUEST, MOVE_LESSONS_SUCCESS, MOVE_LESSONS_FAILURE } from './actions';

const ChooseChild = ({ lessonDates, targetWeeklyProgram, sourcePaymentId, childLessons, child,
	onSourceWeeklyProgramChange, lessonTypes, onLessonTypeChange, lessonType, onMoveLessonsSubmit,
	lessonsFilter, utcOffset, sourceLessonDate, targetLessonDate }) => {

	const { ids, loading } = lessonsFilter;

	if (loading) {
		return <Spinner />;
	}

	const lessonFilter = (l) => {
		return l.child && l.child.id == child.id &&
			// For nomral/paid lessons extract only future dates. For trial lessons extract not attended dates.
			((l.lessonType == 1 && utils.isUpcomingDate(l.start, utcOffset)) || (l.lessonType == 2 && !l.isAttended));
	};

	const lessonsForChild = ids.map(id => childLessons[id]).filter(lesson => lessonFilter(lesson));

	const activePayments = utils.toObject(lessonsForChild.map(lesson => lesson.paymentHistory), 'id');
	const attendsInMorePrograms = Object.keys(activePayments).length > 1;

	// Extract upcoming lesson dates for the target weekly program item.
	const filterTargetLessonDates = () => {
		const lessonDatesForProgram = lessonDates[targetWeeklyProgram.id];
		if (lessonDatesForProgram && lessonDatesForProgram.lessonDates) {
			return lessonDatesForProgram.lessonDates.filter(date => utils.isUpcomingDate(date, utcOffset));
		}

		return [];
	};

	// Determine the current payment. NOTE: Child can be attending to more than one.
	// In this case let the user choose from which one to move the child lessons.
	let selectedSourcePaymentId = undefined;
	if (attendsInMorePrograms) {
		selectedSourcePaymentId = sourcePaymentId;
	} else {
		const payment = utils.first(activePayments);
		selectedSourcePaymentId = payment && payment.id;
	}

	// If we have determined the current weekly program item/items, then make an array.
	let sourceProgramLessons = [];
	if (selectedSourcePaymentId) {
		sourceProgramLessons = lessonsForChild.filter(l => l.paymentHistory.id == selectedSourcePaymentId && l.lessonType == lessonType);
	}

	const initialValues = {
		sourcePaymentId: selectedSourcePaymentId,
		childFullName: child.fullName,
		parentFullName: child.parent && child.parent.fullName,
		sourceWeeklyProgramFullName: utils.first(activePayments) && utils.first(activePayments).name,
		targetWeeklyProgramFullName: targetWeeklyProgram && targetWeeklyProgram.fullName,
		lessonType
	};

	const futureTargetLessonDates = filterTargetLessonDates();
	return (
		<ReduxBlockUi block={MOVE_LESSONS_REQUEST} unblock={[MOVE_LESSONS_SUCCESS, MOVE_LESSONS_FAILURE]}>
			<SettingsForm
				initialValues={initialValues}
				lessonDates={futureTargetLessonDates}
				sourceProgramLessons={sourceProgramLessons}
				attendsInMorePrograms={attendsInMorePrograms}
				activePayments={activePayments}
				onSourceWeeklyProgramChange={onSourceWeeklyProgramChange}
				onLessonTypeChange={onLessonTypeChange}
				lessonTypes={lessonTypes}
				onSubmit={onMoveLessonsSubmit}
				sourceLessonDate={sourceLessonDate}
				targetLessonDate={targetLessonDate}
			/>
		</ReduxBlockUi>
	);
};

export default ChooseChild;